import classnames from "classnames";
import React from "react";
import { Link } from "../../utils/location";
import PencilIcon from "../icons/Pencil.svg";
import * as styles from "./index.module.scss";

export const SelectedOptionBox = ({
  title,
  itemLabel,
  itemIconComponent: IconComponent,
  itemIconStyles,
  itemValueRenderer,
  changeTargetURL,
  onChangeClick,
  changeLabel,
  showEditIcon = true,
  appStyles,
  children,
}) => {
  const showChangeOption = Boolean(changeTargetURL || onChangeClick);
  const ChangeElement = changeTargetURL ? Link : "div";
  const changeElementActionProps = changeTargetURL
    ? { to: changeTargetURL }
    : { onClick: onChangeClick };
  const {
    ServiceOptionBox,
    ServingOptionTitle,
    ChangeServingOptionLink,
    PageHeader = {},
    Card = {},
    LinkButton = {},
    Button = {},
  } = appStyles;

  return (
    <div
      className={classnames(
        styles.ServiceOptionBox,
        appStyles.rtl && styles.RTL,
      )}
      style={{ ...Card, ...ServiceOptionBox }}
    >
      <div className={styles.Header}>
        <div className={styles.ServingOption} style={ServingOptionTitle}>
          {title}
        </div>
        {showChangeOption && (
          <ChangeElement
            {...changeElementActionProps}
            className={styles.ChangeLink}
            style={{
              ...Button,
              ...{
                color: appStyles.actionColor,
                backgroundColor: "transparent",
                boxShadow: "none",
                border: "none",
                backgroundImage: "none",
              },
              ...LinkButton,
              ...ChangeServingOptionLink,
            }}
          >
            {!appStyles.noIcons && showEditIcon && <PencilIcon />}
            {changeLabel}
          </ChangeElement>
        )}
      </div>
      <div
        className={styles.Address}
        style={{ display: "flex", alignItems: "flex-start" }}
      >
        {IconComponent && (
          <span>
            <IconComponent className={itemIconStyles} />
          </span>
        )}
        <span>
          {itemLabel}
          <strong>
            {typeof itemValueRenderer === "function"
              ? itemValueRenderer()
              : itemValueRenderer}
          </strong>
        </span>
      </div>
      <div>{children}</div>
    </div>
  );
};

export default SelectedOptionBox;
